import './key-selection-footer.scss';
import { ArrowLeft } from 'assets/icons';
import { PrivateKeyButton } from 'components';
import { useState } from 'react';
import SignatureIcon from 'assets/icons/signature';
import { IconBtn } from '@ru-digital-assets/ui-component';

interface IKeySelectionFooter {
  onBackButtonClick?: () => void;
  backButtonText?: string;
  submitButtonTitle?: string;
  onSubmit: (privateKey: string) => void;
}

export default function KeySelectionFooter({
  onBackButtonClick,
  backButtonText = 'Вернуться',
  submitButtonTitle = 'Подписать',
  onSubmit,
}: IKeySelectionFooter) {
  const [key, setKey] = useState<string>();

  return (
    <div
      className="key-selection-footer"
      style={{
        justifyContent: onBackButtonClick ? 'space-between' : 'flex-end',
      }}
    >
      {onBackButtonClick && (
        <div
          className="flex align-center cursor-pointer"
          onClick={onBackButtonClick}
        >
          <ArrowLeft className="mr_6" color="#fff" />
          <span style={{ color: '#fff' }}>{backButtonText}</span>
        </div>
      )}
      <div className="flex">
        <div className="mr_16">
          <PrivateKeyButton onKeyChange={(key) => setKey(key)} />
        </div>
        <div style={{ whiteSpace: 'pre' }}>
          <IconBtn
            disabled={!key}
            onClick={() => onSubmit(key!)}
            icon={<SignatureIcon />}
            title={submitButtonTitle}
          />
        </div>
      </div>
    </div>
  );
}
